import { report } from '../../interfaces'
interface reportListProps {
  reports: report[] | null
  setSingleReport: React.Dispatch<React.SetStateAction<report | null>>
  setShowReportModal: React.Dispatch<React.SetStateAction<boolean>>
}
const ReportList = ({
  reports,
  setSingleReport,
  setShowReportModal
}: reportListProps) => {
  return (
    <table className='table-fixed w-full mx-auto mt-20 text-xl'>
      <tbody>
        <tr>
          <th className='border-2 text-center'>Técnico</th>
          <th className='border-2 text-center'>Tipo</th>
          <th className='border-2 text-center'>Fecha</th>
          <th className='border-2 text-center'>Detalle</th>
        </tr>
        {reports?.map((report: report) => {
          return (
            <tr key={report.id}>
              <td className='border-2 text-center'>{report.creator_name}</td>
              <td className='border-2 text-center'>{report.kind_name}</td>
              <td className='border-2 text-center'>{report.date}</td>
              <td className='border-2 text-center'>
                <button
                  className='text-blue-400'
                  onClick={() => {
                    setSingleReport(report)
                    setShowReportModal(true)
                  }}>
                  Ver Detalle
                </button>
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}

export default ReportList
